import { HelperService } from './../_services/helper.service';

/**
 * Interface for date picker configuration options.
 * Used for configuring both legacy mydatepicker and p-calendar components.
 */
export interface DatePickerOptions {
    dateFormat: string;
    editableDateField?: boolean;
    openSelectorOnInputClick?: boolean;
    firstDayOfWeek?: string;
    satHighlight?: boolean;
    inline?: boolean;
    height?: string;
    selectionTxtFontSize?: string;
    disableWeekends?: boolean;
    disableSince?: { year: number; month: number; day: number };
    disableUntil?: { year: number; month: number; day: number };
    disableDays?: Date[];
    todayBtnTxt?: string;
    dayLabels?: Record<string, string>;
    monthLabels?: Record<number, string>;
    componentDisabled?: boolean;
    showTodayBtn?: boolean;
    showClearDateBtn?: boolean;
    alignSelectorRight?: boolean;
    indicateInvalidDate?: boolean;
    minYear?: number;
    maxYear?: number;
    showSelectorArrow?: boolean;
    sunHighlight?: boolean;
}

export class DateSetting {

    defaultDateOptions = {
        dateFormat: 'mm/dd/yyyy',
        editableDateField: false,
        openSelectorOnInputClick: true,
        firstDayOfWeek: 'su',
        satHighlight: true,
        inline: false,
        height: '26px',
        selectionTxtFontSize: '14px',
        disableSince: HelperService.formatInputDate((new Date()).setDate((new Date()).getDate() + 1)).date
    };

    constructor() { }
}
